import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightPipe implements PipeTransform {

  transform(value: string, searchText: string): string {
    if (!value || !searchText) {
      return value;
    }
    // Escape any special regex characters in searchText.
    const escaped = searchText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const re = new RegExp(escaped, 'gi');
    // Replace matching parts with a <mark> tag (which you can style via CSS).
    return value.replace(re, match => `<mark>${match}</mark>`);
  }

}
